import type { MetadataTargetIdentity } from "../../lib/metadata-history/metadata-targets";

export function metadataTargetLabel(target: MetadataTargetIdentity, labels: Record<string, string>, withSection = true) {
  const parts = target.path.split(".");
  const section = !withSection ? "" : target.day ? labels[target.day] : labels.globals;
  const variant = target.day ? labels[parts[2]!] : "";
  const bind = target.bind === "day.date" ? labels.date : labels[target.bind] ?? target.bind;
  const index = Number(parts.at(-1));
  const suffix = Number.isInteger(index) ? ` #${index + 1}` : "";
  return [...new Set([section, variant, bind].filter(Boolean))].join(" · ") + suffix;
}
